import { html, ref, ViewTemplate } from '@microsoft/fast-element';
import { createIcon } from '../../../../styles';
import {
  eventDetail,
  getPriceValue,
  getFormattedNumber,
  getTenorRangePattern,
} from '../../../../utils/formatting';
import { CASCADE_ENUM } from '../../../../services/enum.service';
import { getAbbreviationForCreditProfile } from '../../../../utils/credit-profiles'
import type { AddRFQ } from './add-rfq';

export const AddRFQTemplate: ViewTemplate<AddRFQ> = html`
  <div class="add-rfq-wrapper">
    <div class="header">Create new RFQ</div>
    <div class="vppa-details-wrapper">
      <div class="header">${(x) => x.vppa.TICKER} Details</div>
      <div class="row">
        <span>Ticker</span>
        <span>${(x) => x.vppa.TICKER}</span>
      </div>
      <div class="row">
        <span>Unique ID</span>
        <span>${(x) => x.vppa.UNIQUE_ID}</span>
      </div>
      <div class="row">
        <span>Technology</span>
        <span>${(x) => x.enumService.getEnumTranslation(
          CASCADE_ENUM.TECHNOLOGY,
          x.vppa.TECHNOLOGY)}
        </span>
      </div>
      <div class="row">
        <span>Product Type</span>
        <span>${(x) => x.enumService.getEnumTranslation(
          CASCADE_ENUM.PRODUCT_TYPE,
          x.vppa.PRODUCT_TYPE)}
        </span>
      </div>
      <div class="row">
        <span>Contract Type</span>
        <span>${(x) => x.enumService.getEnumTranslation(
          CASCADE_ENUM.CONTRACT_TYPE,
          x.vppa.CONTRACT_TYPE)}
        </span>
      </div>
      <div class="row">
        <span>ISO</span>
        <span>${(x) => x.vppa.ISO}</span>
      </div>
      <div class="row">
        <span>Settlement Point</span>
        <span>${(x) => x.vppa.SETTLEMENT_POINT}</span>
      </div>
      <div class="row">
        <span>Settlement Point Index</span>
        <span>${(x) => x.enumService.getEnumTranslation(
          CASCADE_ENUM.SETTLEMENT_INDEX,
          x.vppa.SETTLEMENT_INDEX)}
         </span>
      </div>
      <div class="row">
        <span>Fixed Price($/MWh)</span>
        <span>${(x) => x.vppa.FIXED_PRICE}</span>
      </div>
      <div class="row">
        <span>Offered Capacity(MW)</span>
        <span>${(x) => x.vppa.OFFERED_CAPACITY}</span>
      </div>
      <div class="row">
        <span>Tenor</span>
        <span>${(x) => getTenorRangePattern(x.vppa.TENOR_START_DATE, x.vppa.TENOR_MONTHS)}</span>
      </div>
      <div class="row">
        <span>Seller Post-COD Credit Support (Max)</span>
        <span>
          ${(x) => {
            if (x.vppa.SELLER_POST_COD_COLLATERAL && x.vppa.SELLER_POST_COD_COLLATERAL > 0) {
              return getPriceValue(getFormattedNumber(x.vppa.SELLER_POST_COD_COLLATERAL), getAbbreviationForCreditProfile(x.vppa.VPPA_CREDIT_PROFILE));
            }
            return getAbbreviationForCreditProfile(x.vppa.VPPA_CREDIT_PROFILE);
          }}
        </span>
      </div>
      <div class="row">
        <span>Negative Pricing Method</span>
        <span>${(x) => x.enumService.getEnumTranslation(
          CASCADE_ENUM.NEGATIVE_PRICING_METHOD,
          x.vppa.NEGATIVE_PRICING_METHOD)}
        </span>
      </div>
      <div class="row">
        <span>Applicable REC Program</span>
        <span>${(x) => x.enumService.getEnumTranslation(
          CASCADE_ENUM.APPLICABLE_REC_PROGRAM,
          x.vppa.APPLICABLE_REC_PROGRAM)}
        </span>
      </div>
      <div class="row">
        <span>Performance Guarantee Method</span>
        <span>${(x) => x.enumService.getEnumTranslation(
          CASCADE_ENUM.PERFORMANCE_GUARANTEE_METHOD,
          x.vppa.PERFORMANCE_GUARANTEE_METHOD)}
        </span>
      </div>
    </div>
    <div class="add-rfq">
      <rfq-form
        ${ref('rfqForm')}
        @formChanged="${(x, c) => (x.isFormValid = eventDetail(c))}"
      ></rfq-form>
      <div class="button-wrapper">
        <zero-button appearance="secondary" @click=${(x) => x.cancel()}>Cancel</zero-button>
        <zero-button
          appearance="primary"
          ?disabled=${(x) => !x.isFormValid}
          @click=${(x) => x.submitForm()}
        >
          ${createIcon('start')} Create new RFQ
        </zero-button>
      </div>
    </div>
  </div>
`;
